import { Course } from "./courses.model";

export class Agenda {
  constructor(
    public id?: string,
    public title?: string,
    public author?: string,
    public description?: string,
    public initialDate?: string,
    public finalDate?: string,
    public color?: string,
    public topic?: string,
    public link?: string
  ) {}
}
export class Event {
  constructor(
    public id?: string,
    public title?: string,
    public owner?: string,
    public ownerId?: string,
    public hashRoom?: string,
    public url?: string,
    public start?: string,
    public end?: string,
    public calendarId = "group",
    public isPublic?: string,
    public record?: string,
    public hash?: string,
    public videos?: Video[]
  ) {}
}

export class EventForm {
  constructor(
    public id: string = "",
    public name: string = "",
    public classroom: string = "",
    public course: string = "",
    public record: boolean = false,
    public isPublic: boolean = false,
    public startTime: string = "",
    public endTime: string = "",
    public date: Date = new Date(),
    public url: string = "",
  ) {}
}
class Video {
  constructor(
    public id?: string,
    public room_id?: string,
    public video_url?: string,
    public upload_date?: Date | string
  ) {}
}
